<div class="session-expired">
    <mat-card class="session-expired__content" aria-live="polite" role="alert">
        <h4 class="subheading-1">
            <mat-icon aria-label="Info" svgIcon="ico_info_current_color" [attr.aria-hidden]="true"></mat-icon>
            Session expired
        </h4>

        <p class="session-expired__content__body body-1">
            Your session has expired. Choose continue to return to the sign-in screen.
        </p>

        <div class="session-expired__actions">
            <button mat-raised-button class="session-expired__actions__continue" (click)="continueClick()">
                Continue
            </button>
        </div>
    </mat-card>
</div>
